module.exports = __webpack_public_path__ + "img/icon_primary_menu_retail@2x.009e06e8.png";